import { classname } from "@ctra/utils";
import { Col, Row } from "antd";
import { FC } from "react";
import { RightOutlined } from "../../../../..";

import styles from "./ItemWrapper.module.less";

export interface ItemWrapperProps {
  /**
   * Red border if overdue
   */
  isOverdue?: boolean;
  /**
   * on click
   */
  onClick?: () => void;
}

/**
 * Game plan list item wrapper
 * @param isOverdue
 * @param onClick
 */
const ItemWrapper: FC<ItemWrapperProps> = ({ isOverdue, onClick, children }) => {
  return (
    <Row
      align="middle"
      onClick={onClick}
      className={classname(styles.Wrapper, isOverdue ? styles.Overdue : "")}
      data-testid="game-plan"
    >
      {children}
      <Col span={1} className={styles.Arrow}>
        <RightOutlined />
      </Col>
    </Row>
  );
};

export default ItemWrapper;
